<template>
  <div>
    <div class="my-loader" v-if="showLoader">
      <div class="loader-elt">Chargement ...</div>
    </div>
    <div class="blur-bg"></div>
    <div
      v-if="snack"
      class="snack animate__animated animate__backInRight"
      :style="`background-color: ${snackColor} !important`"
    >
      <span class="snack-text">{{ snackText }}</span>
    </div>
    <div class="app-container">
      <!-- This is an example component -->
      <div class="h-screen font-sans bg-cover login">
        <div
          class="container flex items-center justify-center flex-1 h-full mx-auto "
        >
          <div class="w-full max-w-lg">
            <div class="leading-loose">
              <img
                src="@/assets/img/logo_color.png"
                class="w-48 mx-auto -mt-24"
              />
              <form
                @submit.prevent="login"
                class="relative max-w-sm p-10 m-4 mx-auto mt-12 bg-white bg-opacity-25 rounded shadow-xl "
              >
                <div
                  class="absolute inset-0 transform bg-green-700 rounded shadow-2xl  -rotate-12"
                  style=""
                ></div>
                <div
                  class="absolute inset-0 transform rounded shadow-2xl  bg-stratoblue rotate-12"
                  style=""
                ></div>
                <div
                  class="absolute inset-0 transform bg-white rounded shadow-4xl"
                  style=""
                ></div>
                <div
                  class="w-full h-full transform bg-transparent rounded"
                  style=""
                >
                  <p
                    class="text-lg font-medium font-extrabold text-center text-gray-800 "
                  >
                    Se connecter
                  </p>
                  <div class="mt-4">
                    <label
                      class="block text-sm font-bold text-gray-800"
                      for="email"
                      >E-mail</label
                    >
                    <input
                      v-model="user.email"
                      class="w-full px-5 py-1 text-gray-700 bg-gray-300 rounded  focus:outline-none focus:bg-white"
                      type="email"
                      id="email"
                      placeholder="Entrez votre addresse E-mail"
                      aria-label="email"
                      required
                    />
                  </div>
                  <div class="mt-8">
                    <label class="block text-sm font-bold text-gray-800"
                      >Mot de passe</label
                    >
                    <input
                      class="w-full px-5 py-1 text-gray-700 bg-gray-300 rounded  focus:outline-none focus:bg-white"
                      type="password"
                      v-model="user.password"
                      id="password"
                      placeholder="Entrez votre mot de passe"
                      arial-label="password"
                      required
                    />
                  </div>

                  <div class="flex items-center justify-between mt-4">
                    <button
                      class="px-4 py-1 font-light tracking-wider text-white rounded  bg-stratoblue hover:bg-gray-800"
                      type="submit"
                    >
                      Se connecter
                    </button>
                    <a
                      class="right-0 hidden inline-block text-sm font-bold text-white align-baseline  text-500 hover:text-red-400"
                      href="#"
                      >Esqueceu a senha ?</a
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import YouTube from "vue3-youtube";

export default {
  // components: { YouTube },

  data: () => ({
    snack: false, // snack status
    snackText: "lorem ipsum dolor sit amet consectum", // snack message
    snackColor: "", // snack color
    snackDuration: 3000, // snack color

    showLoader: false,
    stratoUrl: "https://www.youtube.com/watch?v=brZT-DQHNbg",

    baseUri: "http://stratochange-001-site7.btempurl.com",
    internetAccess: false, // Situation de la connexion à internet & statut des requetes vers l'API

    user: { email: "", password: "" }, // Login details
  }),

  methods: {
    onReady() {
      this.$refs.youtube.playVideo();
    },
    /**
     * Paramètre et Affiche une message splash
     *
     * @param {String} color la couleur adequate
     * @param {String} text le texte à afficher
     */
    showAlert(color, text) {
      this.snackColor = color;
      this.snackText = text;
      this.snack = true;

      setTimeout(() => {
        this.snack = false;
      }, this.snackDuration);
    },

    /** Gestion de l'authentification avec l'API */
    async login() {
      //this.showLoader = true;
      this.$swal.fire("Veuillez patienter");
      this.$swal.showLoading();

      await axios
        .get(
          this.baseUri +
            "/UsersQueries/GetUserLogin?email=" +
            this.user.email +
            "&password=" +
            this.user.password
        )
        .then((response) => {
          localStorage.setItem("user-connected", "connected");
          localStorage.setItem(
            "stratochange.user",
            JSON.stringify(response.data)
          );

          this.$router.push({ path: "/" }).catch(() => {});
          this.$swal.close();
        })
        .catch(() => {
          //this.$swal.hideLoading();
          this.$swal.fire({
            icon: "error",
            title: "Une erreur est survenue !",
          });
        })
        .finally(() => {
          this.$swal.hideLoading();
        });
    },

    /** Gestion de l'authentification ave le Local Storage */
    loginLocal() {
      localStorage.setItem("user-connected", "connected");
      localStorage.setItem("stratochange.user", JSON.stringify(this.user));

      this.$router.push({ path: "/" });
    },
  },

  mounted() {
    if (
      window.localStorage.getItem("strato-logout") !== null &&
      window.localStorage.getItem("strato-logout").length > 0
    ) {
      this.swal.fire({ icon: "info", title: "Vous vous êtes déconnecté !" });
      window.localStorage.removeItem("strato-logout");
    }
  },
};
</script>

<style lang="css" >
.login {
  /*
    background: url('https://tailwindadmin.netlify.app/dist/images/login-new.jpeg');
  */
  background: url("https://iea.imgix.net/817ded0e-7bb6-4b79-b425-65e6f7b705f1/shutterstock_1484419673.jpg?auto=compress%2Cformat&fit=min&q=80&rect=0%2C517%2C3840%2C1643");
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
